import styled from '@emotion/styled';

export const PurpleSpan = styled.span`
  color: ${(props) => props.theme.color.purple.default};
`;

export const ImageOverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const WaitingTag = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  background: ${(props) => props.theme.color.blue.lightBlue};
  padding: 5px 15px;
  font-size: 13px;
  border-radius: 10px;
  font-weight: 700;
`;
